// import axios from "axios";

// // 1. Create axios instance
// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // 2. Request interceptor - add auth token & event ID
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("rf_token");
//     const eventId = localStorage.getItem("current_event_id");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     // Inject event_id for GET requests if selected, but don't override
//     // explicit params or global admin routes
//     if (eventId && config.method === "get") {
//       config.params = config.params || {};

//       // Only inject if it's NOT an admin route
//       // Because admin routes handle their own scoping explicitly
//       if (
//         !config.url.startsWith("/admin") &&
//         config.params.event_id === undefined
//       ) {
//         config.params.event_id = eventId;
//       }
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// // 3. Response interceptor - handle errors
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Don't redirect if we are already on login or register
//       if (
//         !window.location.pathname.includes("/login") &&
//         !window.location.pathname.includes("/register")
//       ) {
//         localStorage.removeItem("rf_token");
//         window.location.href = "/login";
//       }
//     }
//     return Promise.reject(error);
//   },
// );

// // ===== AUTH API =====
// export const authAPI = {
//   login: (email, password) => api.post("/auth/login", { email, password }),
//   register: (userData) => api.post("/auth/register", userData),
//   getProfile: () => api.get("/auth/me"),
//   updateProfile: (data) => api.put("/users/profile", data),
//   updatePreferences: (prefs) => api.put("/users/profile", prefs),
// };

// // ===== SESSIONS API =====
// export const sessionsAPI = {
//   getAll: (params) => api.get("/sessions", { params }),
//   getById: (id) => api.get(`/sessions/${id}`),
//   getByDay: (day, eventId) => {
//     const params = { day: parseInt(day) || 1 };
//     if (eventId) params.event_id = eventId;
//     return api.get("/sessions", { params });
//   },
//   search: (query) => api.get("/sessions", { params: { search: query } }),
// };

// // ===== SPEAKERS API =====
// export const speakersAPI = {
//   getAll: (eventId) => api.get("/speakers", { params: { event_id: eventId } }),
//   getById: (id) => api.get(`/speakers/${id}`),
//   search: (query, eventId) => api.get("/speakers", { params: { search: query, event_id: eventId } }),
// };

// // ===== SCHEDULE API =====
// export const scheduleAPI = {
//   getMySchedule: () => api.get("/schedule"),
//   addToSchedule: (sessionId) =>
//     api.post("/schedule", { session_id: sessionId }),
//   removeFromSchedule: (sessionId) => api.delete(`/schedule/${sessionId}`),
// };

// // ===== MASTERCLASSES API =====
// export const masterclassesAPI = {
//   getAll: (eventId) => api.get("/masterclasses", { params: { event_id: eventId } }),
//   getById: (id) => api.get(`/masterclasses/${id}`),
//   register: async (id) => {
//     const response = await api.post(`/masterclasses/${id}/register`);
//     // Wrap response for frontend consistency
//     if (!response.data.success && !response.data.status) {
//       response.data = { ...response.data, success: true };
//     }
//     return response;
//   },
//   cancel: (id) => api.delete(`/masterclasses/${id}/register`),
//   joinWaitlist: async (id) => {
//     const response = await api.post(`/masterclasses/${id}/register`);
//     if (response.data.waitlist_position) {
//       response.data.position = response.data.waitlist_position;
//     }
//     return response;
//   },
//   getMyRegistrations: () => api.get("/masterclasses/my-registrations"),
// };

// // ===== ADMIN API =====
// export const adminAPI = {
//   getStats: (eventId) =>
//     api.get("/admin/stats", { params: { event_id: eventId } }),
//   getEvents: () => api.get("/admin/events"),
//   getUsers: () => api.get("/admin/users"),
//   getSessions: (eventId) =>
//     api.get("/admin/sessions", { params: { event_id: eventId } }),
//   getMasterclasses: (eventId) =>
//     api.get("/admin/masterclasses", { params: { event_id: eventId } }),
//   getAttendees: (mcId) => api.get(`/admin/masterclasses/${mcId}/attendees`),
//   updateAttendance: (mcId, userId, isPresent) =>
//     api.post(`/admin/masterclasses/${mcId}/attendance`, {
//       user_id: userId,
//       is_present: isPresent,
//     }),
//   exportData: (mcId) => {
//     window.location.href = `${api.defaults.baseURL}/admin/masterclasses/${mcId}/export`;
//   },
// };

// // ===== QR API =====
// export const qrAPI = {
//   getMyQR: () => api.get("/users/qr-code"),
// };

// // ===== NOTIFICATIONS API =====
// export const notificationsAPI = {
//   getAll: () => api.get("/notifications"),
//   markAsRead: (id) =>
//     api.post("/notifications/mark-read", { notification_ids: [id] }),
//   markAllAsRead: () => api.post("/notifications/mark-all-read"),
//   getUnreadCount: () => api.get("/notifications/unread-count"),
// };

// // ===== SURVEY API =====
// export const surveyAPI = {
//   getSurvey: async () => {
//     const response = await api.get("/surveys");
//     return Array.isArray(response.data) ? response.data[0] : response.data;
//   },
//   submitSurvey: (data) =>
//     api.post(`/surveys/${data.surveyId}/submit`, { answers: data.responses }),
// };

// // ===== PLACEHOLDER APIs (Prevent Crashes) =====
// export const venueAPI = {
//   getMap: () => api.get("/venue/map"),
//   getLocations: () => api.get("/venue/locations"),
// };

// export const helpAPI = {
//   getFAQs: () => api.get("/help/faqs"),
//   getContacts: () => api.get("/help/contacts"),
//   submitQuery: (data) => api.post("/help/query", data),
// };

// // Unified helper object
// export const apiHelpers = {
//   ...authAPI,
//   ...sessionsAPI,
//   ...speakersAPI,
//   ...scheduleAPI,
//   ...masterclassesAPI,
//   ...qrAPI,
//   ...notificationsAPI,
//   ...surveyAPI,
//   ...venueAPI,
//   ...helpAPI,
//   ...adminAPI,
// };

// // FIX: Export the axios instance as 'api' explicitly
// export { api };

// // Default export is also the axios instance
// export default api;

import axios from "axios";

// 1. Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  timeout: 120000,
});

// 2. Request interceptor - add auth token & event ID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("rf_token");
    const eventId = localStorage.getItem("current_event_id");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (eventId && config.method === "get") {
      config.params = config.params || {};
      if (
        !config.url.startsWith("/admin") &&
        config.params.event_id === undefined
      ) {
        config.params.event_id = eventId;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 3. Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (
        !window.location.pathname.includes("/login") &&
        !window.location.pathname.includes("/register")
      ) {
        localStorage.removeItem("rf_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export const authAPI = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  register: (userData) => api.post("/auth/register", userData),
  getProfile: () => api.get("/auth/me"),
  updateProfile: (data) => api.put("/users/profile", data),
  updatePreferences: (prefs) => api.put("/users/profile", prefs),
  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/users/avatar", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  verifyResetCredentials: (email, phone) =>
    api.post("/auth/verify-reset-credentials", { email, phone }),
  resetPassword: (email, phone, newPassword) =>
    api.post("/auth/reset-password", {
      email,
      phone,
      new_password: newPassword,
    }),
};

export const eventsAPI = {
  getById: (id) => api.get(`/admin/events/${id}`),
};

export const sessionsAPI = {
  getAll: (params) => api.get("/sessions/", { params }),
  getById: (id) => api.get(`/sessions/${id}`),
  getByDay: (day) => {
    const dayNum = day === "day1" ? 1 : day === "day2" ? 2 : 1;
    return api.get("/sessions/", { params: { day: dayNum } });
  },
  search: (query) => api.get("/sessions/", { params: { search: query } }),
};

export const speakersAPI = {
  getAll: () => api.get("/speakers"),
  getById: (id) => api.get(`/speakers/${id}`),
  search: (query) => api.get("/speakers", { params: { search: query } }),
};

export const scheduleAPI = {
  getMySchedule: () => api.get("/schedule"),
  addToSchedule: (sessionId) =>
    api.post("/schedule", { session_id: sessionId }),
  removeFromSchedule: (sessionId) => api.delete(`/schedule/${sessionId}`),
};

export const masterclassesAPI = {
  getAll: () => api.get("/masterclasses"),
  getById: (id) => api.get(`/masterclasses/${id}`),
  register: async (id) => {
    const response = await api.post(`/masterclasses/${id}/register`);
    if (!response.data.success && !response.data.status) {
      response.data = { ...response.data, success: true };
    }
    return response;
  },
  cancel: (id) => api.delete(`/masterclasses/${id}/register`),
  joinWaitlist: async (id) => {
    const response = await api.post(`/masterclasses/${id}/register`);
    if (response.data.waitlist_position) {
      response.data.position = response.data.waitlist_position;
    }
    return response;
  },
  getMyRegistrations: () => api.get("/masterclasses/my-registrations"),
};

// ===== ADMIN API (UPDATED WITH REAL METHODS) =====
export const adminAPI = {
  getStats: (eventId) =>
    api.get("/admin/stats", { params: { event_id: eventId } }),
  getEvents: () => api.get("/admin/events"),
  getEvent: (id) => api.get(`/admin/events/${id}`),
  toggleEventActive: (id) => api.patch(`/admin/events/${id}/toggle-active`),
  hardDeleteEvent: (id) => api.delete(`/admin/events/${id}/hard`),
  getUsers: () => api.get("/admin/users"),
  createEvent: (data) => api.post("/admin/events", data),
  updateEvent: (id, data) => api.put(`/admin/events/${id}`, data),

  // Session Management
  getSessions: (eventId) =>
    api.get("/admin/sessions", { params: { event_id: eventId } }),
  createSession: (data) => api.post("/admin/sessions", data),
  updateSession: (id, data) => api.put(`/admin/sessions/${id}`, data),
  deleteSession: (id) => api.delete(`/admin/sessions/${id}`),

  // Masterclass Management
  getMasterclasses: (eventId) =>
    api.get("/admin/masterclasses", { params: { event_id: eventId } }),
  createMasterclass: (data) => api.post("/admin/masterclasses", data),
  updateMasterclass: (id, data) => api.put(`/admin/masterclasses/${id}`, data),
  deleteMasterclass: (id) => api.delete(`/admin/masterclasses/${id}`),
  getAttendees: (mcId) => api.get(`/admin/masterclasses/${mcId}/attendees`),
  updateAttendance: (mcId, userId, isPresent) =>
    api.post(`/admin/masterclasses/${mcId}/attendance`, {
      user_id: userId,
      is_present: isPresent,
    }),
  exportData: (mcId) => {
    window.location.href = `${api.defaults.baseURL}/admin/masterclasses/${mcId}/export`;
  },
  // Speaker Management
  createSpeaker: (data) => api.post("/admin/speakers", data),
  updateSpeaker: (id, data) => api.put(`/admin/speakers/${id}`, data),
  deleteSpeaker: (id) => api.delete(`/admin/speakers/${id}`),
  getSpeakers: () => api.get("/admin/speakers"),

  downloadEventAttendees: async (eventId, format) => {
    const response = await api.get(
      `/admin/events/${eventId}/attendees/export`,
      {
        params: { format },
        responseType: "blob",
      },
    );
    return response;
  },
};

export const qrAPI = {
  getMyQR: () => api.get("/users/qr-code"),
  verify: (id) => api.get(`/users/verify/${id}`),
};

export const notificationsAPI = {
  getAll: (eventId = null, lastId = null) => {
    const params = {};
    if (eventId) params.event_id = eventId;
    if (lastId) params.last_id = lastId;
    return api.get("/notifications", { params });
  },
  markAsRead: (id) =>
    api.post("/notifications/mark-read", { notification_ids: [id] }),
  markAllAsRead: () => api.post("/notifications/mark-all-read"),
  getUnreadCount: (eventId = null) => {
    const params = {};
    if (eventId) params.event_id = eventId;
    return api.get("/notifications/unread-count", { params });
  },
  // Admin endpoints
  sendNotification: (data) => api.post("/admin/notifications", data),
  getAdminNotifications: (eventId = null) => {
    const params = {};
    if (eventId) params.event_id = eventId;
    return api.get("/admin/notifications", { params });
  },
};

export const surveyAPI = {
  getSurvey: async () => {
    const response = await api.get("/surveys");
    return Array.isArray(response.data) ? response.data[0] : response.data;
  },
  submitSurvey: (data) =>
    api.post(`/surveys/${data.surveyId}/submit`, { answers: data.responses }),
};

export const helpAPI = {
  getFAQs: () => api.get("/help/faqs"),
  getContacts: () => api.get("/help/contacts"),
  submitQuery: (data) => api.post("/help/query", data),
};

export const venueAPI = {
  // User endpoints
  getByEvent: (eventId) =>
    api.get("/venues", { params: { event_id: eventId } }),
  // Admin endpoints
  create: (data) => api.post("/admin/venues", data),
  getAll: (eventId = null) => {
    const params = {};
    if (eventId) params.event_id = eventId;
    return api.get("/admin/venues", { params });
  },
  update: (id, data) => api.put(`/admin/venues/${id}`, data),
  delete: (id) => api.delete(`/admin/venues/${id}`),
};


export const apiHelpers = {
  ...authAPI,
  ...sessionsAPI,
  ...speakersAPI,
  ...scheduleAPI,
  ...masterclassesAPI,
  ...qrAPI,
  ...notificationsAPI,
  ...surveyAPI,
  ...venueAPI,
  ...helpAPI,
  ...adminAPI,
};

export { api };
export default api;
